import _, { max } from 'lodash';
import axios from 'axios';
import moment from 'moment';
import classNames from 'classnames';

import React, { useContext, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from 'lottie-react';
import calendarAnimation from 'assets/images/calendar.json';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Box, Paper, IconButton, Typography, Button, Grid } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CheckBoxOutlinedIcon from '@material-ui/icons/CheckBoxOutlined';
import SaveRoundedIcon from '@material-ui/icons/SaveRounded';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import { scheduleShooting, fetchLongDistanceServiceOffer } from 'apis';
import { ShootingContext } from 'contexts';
import { useAlert, useAuth, useLanguage } from 'hooks';
import { ISectionTimeSlots, ITimeSlot } from 'types';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import {
  ALERT,
  CONTACT_EMAIL_ADDRESS,
  CONTACT_PHONE_NUMBER,
  ENG,
  getAPIURL,
  COLOR,
  MODAL,
  SHOOTING_STEPS,
} from 'config/constants';
import { HvHorizontalCalendar, HvGoogleMap, HvPleaseWait, HvButton } from 'components';
import { fetchShootingAsync } from 'state/slices/shootings';
import { ServiceOffer, Shooting } from 'models';
import { images } from 'assets/images';
import { LOADING } from 'state/constants';

const useStyles = makeStyles({
  scrollable: {
    position: 'relative',
    color: '#171F24',
    marginTop: 20,
    overflowY: 'auto',
  },
  timeslots: {
    maxHeight: '100vh',
  },
  group: {
    width: '80%',
    margin: '30px auto 0',

    '&:last-child': {
      marginBottom: 30,
    },
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  groupTitle: {
    textAlign: 'center',
    fontSize: 20,
    fontFamily: 'FordAntenna-Medium',
  },
  groupTimes: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 10,
  },
  loading: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  timeSlotButton: {
    width: '100%',
    alignItems: 'center',
    fontSize: 16,
    backgroundColor: COLOR.ULTRA_LIGHT_GREY,
    borderRadius: 8,
    padding: '8px 10px',
    marginRight: 10,
    marginBottom: 10,
    color: COLOR.CHARCOAL,

    '@media (max-width: 900px)': {
      marginRight: 5,
    },
    '&.Selected': {
      color: COLOR.WHITE,
      backgroundColor: COLOR.LIGHT_BLUE,
    },

    '& .MuiSvgIcon-root': {
      marginRight: 5,
    },
  },
  reviewItem: {
    boxSizing: 'border-box',
    padding: '0 20px',

    '&:last-child': {
      marginBottom: 20,
    },
  },
  message: {
    height: 200,
    fontSize: 18,
    padding: 20,
    whiteSpace: 'pre-wrap',
    fontFamily: 'Ford Antenna',
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
  long_distance_content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 10px',
    borderRadius: 8,
    border: '1px solid #00bdf2',
  },
  reminderContent: {
    padding: '10px 20px',
    backgroundColor: COLOR.LIGHT_YELLOW,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: COLOR.YELLOW,
    marginBottom: 10,
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  reminderText: {
    color: COLOR.DARK_YELLOW,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
    marginBottom: 20,
  },
  backButton: {
    backgroundColor: COLOR.WHITE,
    color: COLOR.LIGHT_BLUE,
    borderColor: COLOR.LIGHT_BLUE,
    marginRight: 20,
    '@media (max-width: 767px)': {
      fontSize: 10,
      marginRight: 5,
    },
  },
  buttonsLeftRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: 10,
    '@media (max-width: 767px)': {
      justifyContent: 'space-between',
    },
  },
  buttonsRightRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginBottom: 10,
    justifyContent: 'flex-end',
    '@media (max-width: 767px)': {
      justifyContent: 'space-between',
    },
  },
  notAvailableContent: {
    padding: 10,
    backgroundColor: COLOR.LIGHT_RED_CONTENT,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: COLOR.RED,
    marginBottom: 10,
  },
  warningText: {
    color: COLOR.RED,
  },
  button: {
    color: COLOR.WHITE,
    backgroundColor: COLOR.LIGHT_BLUE,
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
  pickaday: {
    width: '100%',
    height: 200,
    objectFit: 'contain',
  },
  sunIcon: {
    width: 40,
    height: 'auto',
    alignSelf: 'center',
    marginLeft: 10,
  },
  tilteIconRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    height: '100% !important',
    maxHeight: '100% !important',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    },
  },
  bottomButtons: {
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'row',
    },
  },
  nextButton: {
    color: COLOR.WHITE,
    '@media (max-width: 767px)': {
      fontSize: 12,
      width: '100%',
    },
  },
  reservingContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 400,
    padding: 20,
  },
  reservingTitle: {
    fontSize: 20,
    fontFamily: 'FordAntenna-Medium',
    marginBottom: 15,
  },
  reservingSubtitle: {
    fontSize: 15,
    fontFamily: 'FordAntenna-Light',
  },
  loadingIcon: {
    width: 500,
    height: 'auto',
    marginBottom: 20,
  },
  successIcon: {
    width: 200,
    height: 'auto',
    marginBottom: 20,
    color: COLOR.GREEN,
  },
  textLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  optionsBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  optionBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    height: 30,
    alignItems: 'center',
  },
  checkBox: {
    marginLeft: 5,
  },
  saveButton: {
    color: COLOR.WHITE,
    marginLeft: 20,
    '@media (max-width: 767px)': {
      fontSize: 10,
    },
  },
});

interface Props {
  isUpdateDate: boolean;
  onCancel: () => void;
  setActiveStep: (_: number) => void;
}

function SelectDateTimeStep({ isUpdateDate, onCancel, setActiveStep }: Props) {
  const intl = useIntl();
  const styles = useStyles();
  const language = useLanguage();
  const dispatch = useDispatch();
  const isEn = language === ENG;
  const { token, isAdmin, user } = useAuth();
  const { displayAlert } = useAlert();
  const {
    shooting,
    setLongDistanceServiceOffer,
    longDistanceServiceOffer,
    listing,
    isFake,
    is_same_day_delivery_checked,
    updateShootingFields,
    direct_drive,
    setDirectDrive,
    availabilities,
    isServicable,
    saveShooting,
  } = useContext(ShootingContext);
  const isDraftMode = shooting.state === Shooting.STATE_ENUM.draft;
  const { scheduleddate, ignore_scheduler } = shooting;
  const calcSelectedAndDisableDates = () => {
    if (isAdmin) {
      return {
        date: scheduleddate || null,
        disabledDates: [],
      };
    }

    const today = moment();
    const hour = today.hour();
    let disabledDates = [];

    let firstAvailableDate = null;
    if (isServicable && !availabilities.length) {
      firstAvailableDate = today.add(1, 'days').toDate();
    } else if (isServicable && availabilities.length) {
      const foundFirstAvailableDay = availabilities[0];
      if (foundFirstAvailableDay < today.day()) {
        firstAvailableDate = today.add(7 - today.day() + foundFirstAvailableDay, 'days').toDate();
      }
      if (foundFirstAvailableDay === today.day()) {
        firstAvailableDate = today.toDate();
      }
      if (foundFirstAvailableDay > today.day()) {
        firstAvailableDate = today.add(foundFirstAvailableDay - today.day(), 'days').toDate();
      }
    } else {
      firstAvailableDate = null;
    }
    if (hour < 8) {
      disabledDates = [today.format('YYYYMMDD')];
    }
    return {
      date: scheduleddate || null,
      disabledDates,
    };
  };
  const selectedAndDisabledDates = calcSelectedAndDisableDates();
  const [isReserving, setIsReserving] = useState(false);
  const [loadingLongDistanceServiceOffer, setLoadingLongDistanceServiceOffer] = useState(
    LOADING.NONE,
  );
  const [loadingTimeSlots, setLoadingTimeSlots] = useState(LOADING.NONE);
  const [selectedDate, setSelectedDate] = useState(selectedAndDisabledDates.date);
  const [availableTimesSlots, setAvailableTimeSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [isReviewMode, setIsReviewMode] = useState(false);
  const [isSchedulingError, setIsSchedulingError] = useState(false);
  const [isReserved, setIsReserved] = useState(false);
  const fmtPaidTimeslotsTitle = intl.formatMessage({
    id: 'shooting.create.messages.paidTimeslotsTitle',
  });
  const fmtPaidTimeslotSelected = intl.formatMessage({
    id: 'shooting.create.messages.paidTimeslotSelected',
  });
  const fmtNextMonday = intl.formatMessage({ id: 'shooting.create.messages.nextMonday' });
  const fmtSameDayNotAvailableForWeekend = intl.formatMessage({
    id: 'shooting.create.messages.sameDayServiceSelected',
  });
  const fmtConfirm = intl.formatMessage({ id: 'shooting.create.buttons.confirm' });
  const fmtRetry = intl.formatMessage({ id: 'shooting.create.buttons.retry' });
  const fmtSelectDate = intl.formatMessage({ id: 'shooting.create.messages.pleaseSelectDate' });
  const fmtLoading = intl.formatMessage({
    id: 'shooting.create.messages.searchingAvailableTimeSlots',
  });
  const fmtSaveDraft = intl.formatMessage({ id: 'shooting.create.buttons.saveDraft' });
  const fmtSave = intl.formatMessage({ id: 'shooting.create.buttons.save' });
  const fmtReservingTitle = intl.formatMessage({ id: 'shooting.create.messages.reserving' });
  const fmtPleaseWait = intl.formatMessage({ id: 'shooting.create.messages.pleaseWait' });
  const fmtIgnoreEmail = intl.formatMessage({ id: 'shooting.create.labels.ignore_email' });
  const fmtReserved = intl.formatMessage({ id: 'shooting.create.messages.shootingSuccess' });
  const fmtSuccess = intl.formatMessage({ id: 'shooting.create.messages.success' });
  const fmtBookAnotherShoot = intl.formatMessage({
    id: 'shooting.create.buttons.bookAnotherShoot',
  });
  const fmtGoBackToShootings = intl.formatMessage({
    id: 'shooting.create.buttons.goBackToShootings',
  });
  const fmtAt = intl.formatMessage({ id: 'shooting.create.labels.at' });

  useEffect(() => {
    if (scheduleddate) {
      setSelectedDate(scheduleddate);
    }
  }, [scheduleddate]);

  const selectedDay = selectedDate ? moment(selectedDate).day() : undefined;
  const isSaturday = selectedDay === 6;

  const getSectionTimeSlots = (timeSlots: ITimeSlot[]): ISectionTimeSlots[] => {
    if (!timeSlots.length) return [];

    const availableTimeslots = [
      { title: 'morning', timeSlots: [] },
      { title: 'afternoon', timeSlots: [] },
    ];

    timeSlots.forEach((m: ITimeSlot) => {
      if (moment(m.readableHoursEST, 'HH:mm').hours() < 12) {
        availableTimeslots[0].timeSlots.push(m);
      } else {
        availableTimeslots[1].timeSlots.push(m);
      }
    });

    return availableTimeslots;
  };

  const getAvailableTimeslots = async (date: Date) => {
    if (!Number(listing?.lat || 0.0) || !Number(listing?.lng || 0.0)) {
      return;
    }
    const selectedDay = date ? moment(date).day() : undefined;
    const isWeekend = selectedDay === 6 || selectedDay === 0;
    if (!(is_same_day_delivery_checked && isWeekend)) {
      const _serviceOffers = JSON.stringify(
        shooting.service_offers.map((item: ServiceOffer) => {
          return {
            id: item.serviceOffer.id,
            name: item.serviceOffer.key_name,
            price: item.serviceOffer.price,
            type_value_map: item.type_value_map,
          };
        }),
      );

      const _shootingParams = JSON.stringify({
        shooting_package_id: shooting.shooting_params?.shooting_package?.id,
        shooting_package_included_service_offers:
          shooting.shootingPackage?.included_service_offers ?? [],
        amenities: shooting.shooting_params?.amenities ?? [],
      });

      const params: any = {
        lat: listing.lat,
        lng: listing.lng,
        city: listing.city,
        address: listing.address,
        timestamp: date,
        postalcode: listing.postalcode,
        room_count: shooting.shooting_params.room_count,
        property_type: listing.property_type,
        service_offers: _serviceOffers,
        shooting_params: _shootingParams,
        ignore_scheduler: shooting.ignore_scheduler,
        ignore_email: shooting.ignore_email,
        direct_drive,
      };

      if (shooting.id !== -1) {
        params.shooting_id = shooting.id;
      }

      setSelectedTimeSlot(null);
      setLoadingTimeSlots(LOADING.STARTED);
      try {
        const config = { headers: { token }, params };
        const response: any = await axios.get(`${getAPIURL()}/availableTimeslots`, config);
        const sections = getSectionTimeSlots(response.data.timeslots);
        setAvailableTimeSlots(sections);
        setLoadingTimeSlots(LOADING.FINISHED);
      } catch {
        displayAlert(
          ALERT.ERROR,
          intl.formatMessage({ id: 'shooting.create.messages.timeSlotsErrorOccured' }),
        );
        setAvailableTimeSlots([]);
        setLoadingTimeSlots(LOADING.FINISHED);
      }
    }
  };
  const checkAvailability = (date: Date) => {
    const day = moment(date).day();
    const isWeedkend = day === 6 || day === 0;
    const isSameDayServiceOnWeekend = is_same_day_delivery_checked && isWeedkend;
    if (shooting.ignore_scheduler) {
      return true;
    }
    if (isSameDayServiceOnWeekend) {
      return false;
    }
    if (direct_drive) {
      return true;
    }
    if (!isServicable) {
      return false;
    }
    if (isServicable && !availabilities.length) {
      return true;
    }
    // remove availabilities for weekend
    const foundAvailability = availabilities.includes(day);
    return foundAvailability;
  };
  const getLongDistanceServiceOffer = async (brokerId: number) => {
    try {
      setLoadingLongDistanceServiceOffer(LOADING.STARTED);
      const res = await fetchLongDistanceServiceOffer(token, brokerId);
      if (res) {
        setLongDistanceServiceOffer(res);
      }
      setLoadingLongDistanceServiceOffer(LOADING.FINISHED);
    } catch {
      displayAlert(
        ALERT.ERROR,
        intl.formatMessage({ id: 'shooting.create.messages.shootingError' }),
      );
    }
  };
  useEffect(() => {
    const _brokerId = user.isAdmin ? listing?.broker_id || user.id : user.id;
    if (_brokerId) {
      getLongDistanceServiceOffer(_brokerId);
    }
  }, []);
  useEffect(() => {
    if ((selectedDate && checkAvailability(new Date(selectedDate))) || scheduleddate) {
      const { date } = calcSelectedAndDisableDates();
      getAvailableTimeslots(new Date(selectedDate || date));
    } else {
      setSelectedDate(null);
      setAvailableTimeSlots([]);
    }
  }, [listing, direct_drive, is_same_day_delivery_checked, scheduleddate, ignore_scheduler]);

  const onDateChange = (date: any) => {
    if (date && checkAvailability(new Date(date))) {
      setSelectedDate(date);
      getAvailableTimeslots(new Date(date));
    } else {
      setSelectedDate(null);
      setAvailableTimeSlots([]);
    }
  };

  const onPreviousStep = () => {
    setActiveStep(SHOOTING_STEPS.REVIEW);
  };

  const onSelectAnotherTime = () => {
    setSelectedTimeSlot(null);
    setIsReviewMode(false);
    if (selectedDate && checkAvailability(new Date(selectedDate))) {
      getAvailableTimeslots(new Date(selectedDate));
    }
  };

  const onReview = () => {
    setIsReviewMode(true);
  };

  const checkSaveButtonVisibility = () => {
    if (!isDraftMode && shooting?.id) {
      return false;
    }
    return true;
  };
  const onIgnoreSchedulerConfirmChange = () => {
    updateShootingFields({ ignore_scheduler: !shooting.ignore_scheduler });
  };

  const onIgnoreEmailChange = () => {
    updateShootingFields({ ignore_email: !shooting.ignore_email });
  };
  const onConfirm = async () => {
    setIsReserving(true);

    const newShooting = await scheduleShooting(token, selectedTimeSlot, shooting, listing, isFake);
    if (newShooting) {
      setIsReserving(false);
      setIsReserved(true);
    } else {
      setIsReserving(false);
      setIsSchedulingError(true);
      displayAlert(
        ALERT.ERROR,
        intl.formatMessage({ id: 'shooting.create.messages.shootingError' }),
      );
    }
  };

  const bookAnotherShoot = () => {
    window.location.href = '/shooting';
  };

  const goBackToShootings = () => {
    window.location.href = '/shootings';
  };
  const onRetry = () => {
    setIsSchedulingError(false);
    onSelectAnotherTime();
  };

  const onClickLongDistance = () => {
    if (
      loadingLongDistanceServiceOffer === LOADING.STARTED ||
      loadingLongDistanceServiceOffer === LOADING.STARTED
    ) {
      return;
    }
    setDirectDrive(!direct_drive);
  };

  const renderNoSelectedDate = () => {
    return (
      <div>
        <img className={styles.pickaday} src={images.pickaday} alt='pick a day' />
        <div className={styles.reminderContent}>
          <img className={styles.icon} src={images.select} alt='select date' />
          <Typography className={styles.reminderText}>{fmtSelectDate}</Typography>
        </div>
      </div>
    );
  };
  const renderWarningContent = () => {
    return (
      <pre className={styles.message}>
        {intl.formatMessage({
          id: direct_drive
            ? 'shooting.create.messages.noAvailabeTimeSlots'
            : 'shooting.create.messages.noScheduleFoundNoDirectDrive',
        })}
        <br />
        <br />
        <Link href={`mailto:${CONTACT_EMAIL_ADDRESS}`} underline='none'>
          {CONTACT_EMAIL_ADDRESS}
        </Link>
        {` (${CONTACT_PHONE_NUMBER})`}
      </pre>
    );
  };
  const renderTimeSlots = () => {
    const isLoading =
      loadingTimeSlots === LOADING.STARTED || loadingLongDistanceServiceOffer === LOADING.STARTED;
    return (
      <Box className='FlexBox Vertical'>
        {isLoading && (selectedDate || scheduleddate) ? (
          <>
            <HvPleaseWait className={styles.loading} />
            <Typography className={styles.message}>{fmtLoading}</Typography>
          </>
        ) : null}
        {!selectedDate && !scheduleddate && renderNoSelectedDate()}
        {loadingTimeSlots === LOADING.FINISHED &&
        loadingLongDistanceServiceOffer === LOADING.FINISHED &&
        !availableTimesSlots.length
          ? renderWarningContent()
          : null}

        {loadingTimeSlots === LOADING.FINISHED &&
          availableTimesSlots.map((section: ISectionTimeSlots) => {
            if (!section.timeSlots.length) return null;

            return (
              <Box key={section.title} className={styles.group}>
                <Box className={styles.tilteIconRow}>
                  <Typography className={classNames('Bold', styles.groupTitle)}>
                    {intl.formatMessage({ id: `shooting.create.labels.${section.title}` })}
                  </Typography>
                  <img className={styles.sunIcon} src={images[section.title]} alt={section.title} />
                </Box>
                <Grid container spacing={1} className={styles.groupTimes}>
                  {section.timeSlots.map((m: ITimeSlot) => {
                    return (
                      <Grid item md={2} sm={6} xs={6}>
                        <IconButton
                          key={m.readableHoursEST}
                          className={classNames(styles.timeSlotButton, {
                            Selected: selectedTimeSlot?.readableHoursEST === m.readableHoursEST,
                          })}
                          onClick={() => {
                            setSelectedTimeSlot(m);
                          }}
                        >
                          {direct_drive && m.direct_drive ? (
                            <img
                              className={styles.icon}
                              src={
                                selectedTimeSlot?.readableHoursEST === m.readableHoursEST
                                  ? images.extra_phographers_white
                                  : images.extra_photographers_blue
                              }
                              alt='long distance'
                            />
                          ) : (
                            <AccessTimeIcon
                              style={{
                                color:
                                  selectedTimeSlot?.readableHoursEST === m.readableHoursEST
                                    ? COLOR.WHITE
                                    : COLOR.LIGHT_BLUE,
                              }}
                            />
                          )}
                          <Typography>{m.readableHoursEST}</Typography>
                        </IconButton>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            );
          })}
      </Box>
    );
  };

  const renderSummary = () => {
    if (isReserving) {
      return (
        <div className={styles.reservingContent}>
          <Lottie animationData={calendarAnimation} className={styles.loadingIcon} />
          <Typography className={styles.reservingTitle}>{fmtReservingTitle}</Typography>
          <Typography className={styles.reservingSubtitle}>{fmtPleaseWait}</Typography>
        </div>
      );
    }
    if (isReserved) {
      return (
        <div className={styles.reservingContent}>
          <img className={styles.successIcon} src={images.confirmed} alt='confirmation' />
          <Typography className={styles.reservingTitle}>{fmtSuccess}</Typography>
          <Typography>
            {`${fmtReserved} ${listing.cityAddressWithPostalCode}
             ${fmtAt} ${selectedTimeSlot?.readableHoursEST}
             ${moment(selectedTimeSlot?.date).format('D MMMM YYYY')}`}
          </Typography>
        </div>
      );
    }
    return (
      <Box className='FlexBox Vertical'>
        <HvGoogleMap lat={Number(listing.lat)} lng={Number(listing.lng)} />

        <Box className={classNames('FlexBox Vertical', styles.reviewItem)}>
          <Typography className='InfoItem_Label'>
            {intl.formatMessage({ id: 'address' })}
          </Typography>
          <Typography>{listing.cityAddressWithPostalCode}</Typography>
        </Box>

        <Box className={classNames('FlexBox Vertical', styles.reviewItem)}>
          <Typography className='InfoItem_Label'>
            {intl.formatMessage({ id: 'shooting.create.labels.dateTime' })}
          </Typography>
          <Typography>
            {`${moment(selectedTimeSlot?.date).format('D MMMM YYYY')}  ${
              selectedTimeSlot?.readableHoursEST
            }`}
          </Typography>
        </Box>
        {selectedTimeSlot?.direct_drive ? (
          <Box className={classNames('FlexBox Vertical', styles.reviewItem)}>
            <Typography>{fmtPaidTimeslotsTitle}</Typography>
            <Typography>
              {`${longDistanceServiceOffer.price}$ ${fmtPaidTimeslotSelected}`}
            </Typography>
          </Box>
        ) : null}
        <Box className={classNames('FlexBox Vertical', styles.reviewItem)}>
          <Typography className='InfoItem_Label'>
            {intl.formatMessage({ id: 'shooting.create.labels.canllelation' })}
          </Typography>
          <Typography>
            {intl.formatMessage({ id: 'shooting.create.labels.cancellationPolicy' })}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <div>
      {isReserving || isReserved ? null : (
        <h1>{intl.formatMessage({ id: 'shooting.create.titles.selectDateTime' })}</h1>
      )}
      {user.isAdmin && !isReviewMode ? (
        <Grid container className={styles.optionsBox}>
          <Grid item md={3} className={styles.optionBox}>
            <Typography>
              {intl.formatMessage({ id: 'shooting.create.labels.ignore_scheduler' })}
            </Typography>
            <IconButton
              disabled={
                loadingTimeSlots === LOADING.STARTED ||
                loadingLongDistanceServiceOffer === LOADING.STARTED
              }
              onClick={onIgnoreSchedulerConfirmChange}
              className={styles.checkBox}
            >
              {shooting.ignore_scheduler ? (
                <CheckBoxOutlinedIcon
                  style={{
                    color:
                      loadingTimeSlots === LOADING.STARTED ||
                      loadingLongDistanceServiceOffer === LOADING.STARTED
                        ? COLOR.GREY
                        : COLOR.LIGHT_BLUE,
                  }}
                  color='secondary'
                />
              ) : (
                <CheckBoxOutlineBlankOutlinedIcon
                  style={{
                    color:
                      loadingTimeSlots === LOADING.STARTED ||
                      loadingLongDistanceServiceOffer === LOADING.STARTED
                        ? COLOR.GREY
                        : COLOR.LIGHT_BLUE,
                  }}
                  color='secondary'
                />
              )}
            </IconButton>
          </Grid>
          <Grid item md={3} className={styles.optionBox}>
            <Typography>{fmtIgnoreEmail}</Typography>
            <IconButton
              disabled={
                loadingTimeSlots === LOADING.STARTED ||
                loadingLongDistanceServiceOffer === LOADING.STARTED
              }
              onClick={onIgnoreEmailChange}
              className={styles.checkBox}
            >
              {shooting.ignore_email ? (
                <CheckBoxOutlinedIcon
                  style={{
                    color:
                      loadingTimeSlots === LOADING.STARTED ||
                      loadingLongDistanceServiceOffer === LOADING.STARTED
                        ? COLOR.GREY
                        : COLOR.LIGHT_BLUE,
                  }}
                  color='secondary'
                />
              ) : (
                <CheckBoxOutlineBlankOutlinedIcon
                  style={{
                    color:
                      loadingTimeSlots === LOADING.STARTED ||
                      loadingLongDistanceServiceOffer === LOADING.STARTED
                        ? COLOR.GREY
                        : COLOR.LIGHT_BLUE,
                  }}
                  color='secondary'
                />
              )}
            </IconButton>
          </Grid>
        </Grid>
      ) : null}
      {!isReviewMode ? (
        <HvHorizontalCalendar
          selectedDate={selectedDate as unknown as Date}
          scheduleddate={scheduleddate ? new Date(scheduleddate) : undefined}
          disabledDates={selectedAndDisabledDates.disabledDates}
          onChange={onDateChange}
          isServicable={isServicable}
          direct_drive={direct_drive}
          availabilities={isAdmin ? [] : availabilities}
          checkAvailability={checkAvailability}
          isLoadingTimeslots={loadingTimeSlots === LOADING.STARTED}
        />
      ) : null}
      {is_same_day_delivery_checked && direct_drive ? (
        <Box className={styles.reminderContent}>
          <Typography className={styles.reminderText}>
            {fmtSameDayNotAvailableForWeekend}
          </Typography>
        </Box>
      ) : null}
      {isSaturday ? (
        <Box className={styles.reminderContent}>
          <Typography className={styles.reminderText}>{fmtNextMonday}</Typography>
        </Box>
      ) : null}
      {longDistanceServiceOffer && !isReviewMode ? (
        <div className={styles.long_distance_content}>
          <div className={styles.tilteIconRow}>
            <img
              className={styles.icon}
              src={images.extra_photographers_blue}
              alt='long distance'
            />
            <Typography>
              {isEn
                ? longDistanceServiceOffer.description
                : longDistanceServiceOffer.description_fr}
              {`(${longDistanceServiceOffer.price} $)`}
            </Typography>
          </div>
          <IconButton
            disabled={
              loadingTimeSlots === LOADING.STARTED ||
              loadingLongDistanceServiceOffer === LOADING.STARTED
            }
            onClick={onClickLongDistance}
          >
            {direct_drive ? (
              <CheckBoxOutlinedIcon
                style={{
                  color:
                    loadingTimeSlots === LOADING.STARTED ||
                    loadingLongDistanceServiceOffer === LOADING.STARTED
                      ? COLOR.GREY
                      : COLOR.LIGHT_BLUE,
                }}
              />
            ) : (
              <CheckBoxOutlineBlankOutlinedIcon
                style={{
                  color:
                    loadingTimeSlots === LOADING.STARTED ||
                    loadingLongDistanceServiceOffer === LOADING.STARTED
                      ? COLOR.GREY
                      : COLOR.LIGHT_BLUE,
                }}
              />
            )}
          </IconButton>
        </div>
      ) : null}
      <Paper
        className={classNames(styles.scrollable, !isReviewMode ? styles.timeslots : null)}
        elevation={0}
      >
        {isReviewMode ? renderSummary() : renderTimeSlots()}
      </Paper>

      {isReserved ? (
        <div className={classNames('ButtonsBox', styles.buttons)}>
          <div className={styles.buttonsLeftRow}>
            <Typography className={styles.textLink} onClick={bookAnotherShoot}>
              {fmtBookAnotherShoot}
            </Typography>
          </div>
          <div className={styles.buttonsRightRow}>
            <HvButton onClick={goBackToShootings}>
              <Typography>{fmtGoBackToShootings}</Typography>
            </HvButton>
          </div>
        </div>
      ) : (
        <Box className={classNames('ButtonsBox', styles.buttons)}>
          <div className={styles.buttonsLeftRow}>
            {isReviewMode ? (
              <Button
                variant='contained'
                color='secondary'
                className={styles.saveButton}
                style={{ marginLeft: 0 }}
                onClick={onSelectAnotherTime}
                disabled={isReserving}
              >
                <Typography>
                  {intl.formatMessage({ id: 'shooting.create.buttons.selectAnotherTime' })}
                </Typography>
              </Button>
            ) : (
              <Button variant='contained' className='BackButton' onClick={onCancel}>
                <Typography>
                  {intl.formatMessage({ id: 'shooting.create.buttons.cancel' })}
                </Typography>
              </Button>
            )}
            {checkSaveButtonVisibility() && (
              <Button
                variant='contained'
                color='secondary'
                className={styles.saveButton}
                onClick={saveShooting}
              >
                <SaveRoundedIcon />
                <Typography>{isDraftMode || !shooting.id ? fmtSaveDraft : fmtSave}</Typography>
              </Button>
            )}
          </div>

          <div className={styles.buttonsRightRow}>
            {!isUpdateDate ? (
              <Button
                variant='outlined'
                disabled={isReserving}
                className={styles.backButton}
                onClick={onPreviousStep}
              >
                <ChevronLeftRoundedIcon />
                <Typography>
                  {intl.formatMessage({ id: 'shooting.create.buttons.back' })}
                </Typography>
              </Button>
            ) : null}

            {isReviewMode ? (
              <Button
                variant='contained'
                color='secondary'
                className={styles.saveButton}
                disabled={!selectedTimeSlot || isReserving}
                onClick={isSchedulingError ? onRetry : onConfirm}
              >
                <Typography>{isSchedulingError ? fmtRetry : fmtConfirm}</Typography>
              </Button>
            ) : (
              <Button
                variant='contained'
                color='secondary'
                className={styles.saveButton}
                disabled={!selectedTimeSlot || isReserving}
                onClick={onReview}
              >
                <Typography>
                  {intl.formatMessage({ id: 'shooting.create.buttons.review' })}
                </Typography>
              </Button>
            )}
          </div>
        </Box>
      )}
    </div>
  );
}

export default SelectDateTimeStep;
